<script setup lang="ts">
import { useRouter } from 'vue-router';

import StartLogo from '@/ui/StartLogo.vue';

const props = withDefaults(defineProps<{
  name?: string;
  message?: string;
  redirectUrl?: string;
}>(), {
  name: 'login',
  message: 'Redirecting to login...',
});
const router = useRouter();
const redirect = props.redirectUrl ? btoa(props.redirectUrl) : undefined;
router.push({ name: props.name, query: { redirect } });
</script>

<template>
  <StartLogo :text="message" :percent="100" />
</template>
